<div class="repair-line-items-toolbar">
  <div class="repair-line-items-filters" #filterBar>
    @for (field of filterFields; track field.id) {
      @let position = filterPositions()[field.id];
      <mc-input
        class="repair-line-items-filter"
        [style.left.px]="position?.left ?? 0"
        [style.width.px]="position?.width ?? 0"
        [style.visibility]="position ? 'visible' : 'hidden'"
        [label]="field.label"
        hiddenlabel
        fit="small"
        clearbutton
        [placeholder]="field.label"
        [value]="filter().filters()[field.id]"
        (input)="onFilterChange(field.id, $event)"
        (clearbuttonclick)="filter().setFilter(field.id, '')"></mc-input>
    }
  </div>
  <div class="repair-line-items-actions">
    @if (filter().hasActiveFilters()) {
      <mc-button
        fit="small"
        appearance="neutral"
        variant="plain"
        icon="times"
        label="Clear filters"
        (click)="filter().clearFilters()"
        (keydown.enter)="$event.preventDefault(); filter().clearFilters()"
        (keydown.space)="$event.preventDefault(); filter().clearFilters()"></mc-button>
    }
    @if (filter().rowsWithParts().length > 0) {
      <mc-button
        fit="small"
        appearance="neutral"
        variant="outlined"
        [icon]="filter().allExpanded() ? 'chevron-up' : 'chevron-down'"
        [label]="filter().allExpanded() ? 'Collapse all' : 'Expand all'"
        (click)="filter().toggleExpandAll()"
        (keydown.enter)="$event.preventDefault(); filter().toggleExpandAll()"
        (keydown.space)="$event.preventDefault(); filter().toggleExpandAll()"></mc-button>
    }
  </div>
</div>
<mc-table
  #repairTable
  outerborderstyle="none"
  disablerowhighlightonhover="true"
  [data]="filter().filteredData()"
  [expandopened]="filter().expandedRows()"
  fit="small"
  [columns]="columns()"
  tabularFigures="true"
  (sortchange)="sortChange.emit($event)"
  expand>
  @if (filter().filteredData().length === 0) {
    <div slot="state" class="repair-line-items-empty">No repair line items match the filters</div>
  }
  @for (item of filter().rows(); track item.id) {
    @if (item.parts && item.parts.length > 0) {
      <app-list-repair-part-items
        [slot]="item.id + '_expanded'"
        [repairParts]="item.parts"
        [maintainceOrderStatus]="maintainceOrderStatus()"
        [maintenanceOrderSourceApplication]="maintenanceOrderSourceApplication()"></app-list-repair-part-items>
    }
    <div [slot]="item.id + '_attachments'">
      <app-file-upload
        type="compact"
        [readOnly]="true"
        [inputFiles]="item.files"
        [workOrderMode]="workOrderMode()"
        [inspectionDetailsWithLine]="undefined">
      </app-file-upload>
    </div>
  }
  <ng-content />
</mc-table>
